import { DeviationRequestHistoryRecord, DeviationRequestPermissions } from 'api/deviation-request-detail';
import { autoinject, BindingEngine, computedFrom } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { DeviationRequestBase, DeviationRequestWorkflowStrategy } from 'model/forms/deviation-request';
import { KeywordsService } from 'services/keywords-service';
import { LookupsService } from 'services/lookups-service';
import { ModelBase } from 'support/base_classes/model-base';
import { EnumsService } from 'services/enums-service';
import { DeviationRequestStatus } from 'model/business-enums';
import { DateValueConverter } from 'framework/value_converters/date-and-time';
import { ValidationController } from 'aurelia-validation';
import { RequestAttachmentsController } from './request-attachments-panel';

@autoinject
export abstract class DeviationRequestFormCustomElement<TModel extends DeviationRequestBase> extends ModelBase<TModel> {
  @bindable permissions: DeviationRequestPermissions;
  @bindable history: DeviationRequestHistoryRecord[];
  @bindable autofocus = false;
  @bindable disabled = false;
  @bindable attachmentPanelDisabled = false;
  @bindable supportValidationController: ValidationController;
  @bindable attachmentsController: RequestAttachmentsController = null;
  @bindable workflowStrategy: DeviationRequestWorkflowStrategy;
  isNew = false;

  constructor(bindingEngine: BindingEngine, protected lookups: LookupsService, protected keywords: KeywordsService, protected enums: EnumsService) {
    super(bindingEngine);
  }

  modelChanged(newValue: TModel) {
    super.modelChanged(newValue);
    this.isNew = this.model.id == null;
  }

  keywordsItemMatcher = this.keywords.itemsMatch;
  usersLookupOptions = this.lookups.getUsersLookupOptions();

  @computedFrom('model.requestedBy')
  get requestedByGroupLabel() {
    return ['Requestor / bp employee name', this.model.requestedBy?.mail, this.model.requestedBy?.phone].filter(l => l != null);
  }

  @computedFrom('model')
  get assignedToLabel() {
    const teamName = this.enums.deviationWorkflowTypes.filter(x => x.value === this.model.workflowType)[0].name;
    return this.model.assignedTo !== null ? `Assigned to ${teamName} Team member on ${new DateValueConverter().toView(this.model.assignedOn)}` : `Not assigned`;
  }

  @computedFrom('model.status')
  get statusLabel() {
    return `${this.enums.deviationRequestStatuses.filter(x => x.value === this.model.status)[0].name} ${[DeviationRequestStatus.Rejected].includes(this.model.status) ? 'on' : 'since'} ${new DateValueConverter().toView(this.model.statusChangedOn)}`;
  }

  @computedFrom('model.status')
  get statusClass() {
    return `at-deviation-request-status --${DeviationRequestStatus[this.model.status].toLowerCase()}`;
  }
}
